import React, { Component } from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow
} from 'devextreme-react/data-grid';
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarMultaDs } from "../DataSources";
import uiInfo from "../ui-info";
import UserInfo from "../UserInfo";

export default class MultasBox extends Component {
    constructor() {
        super();
        this._grid = React.createRef();
        this.dataSource = criarMultaDs();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Cadastro de Multas">
                        <DataGrid
                            ref={grid => this._grid = grid}
                            dataSource={this.dataSource}
                            showBorders={true}
                            rowAlternationEnabled={true} remoteOperations={true} 
                            focusedRowEnabled={true}
                            onInitNewRow={this.initNewRow}>
                            <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true}  useIcons={true}/>
                            <Column dataField={'data'} caption={"Data"} dataType={"date"} format={uiInfo.formatoData.dataCurta} />
                            <Column dataField={'percentualPorDia'} caption={"% dia"} format={uiInfo.formatoNumerico.n2} />
                            <Column dataField={'limite'} caption={"% Máximo"} format={uiInfo.formatoNumerico.n2} />
                            <Paging defaultPageSize={20} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                                defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    
    initNewRow(e){
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}
